'use client';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { SmallAndAbove } from '@lichtblick/theme';
import styled, { css } from 'styled-components';
const videoStyles = css`
  max-width: 100%;
`;
const VideoMobile = styled.video`
  ${videoStyles}

  @media ${SmallAndAbove} {
    display: none;
  }
`;
const VideoDesktop = styled.video`
  ${videoStyles}

  @media not ${SmallAndAbove} {
    display: none;
  }
`;
const getSourceProps = (videoUrls)=>videoUrls.filter(Boolean).map((src)=>({
            key: src,
            src,
            type: `video/${src.split('.').pop()?.toLowerCase()}`
        }));
export const Video = ({ description, posterUrl, urls, ...videoProps })=>{
    const sourcesMobile = getSourceProps(urls.mobile);
    const sourcesDesktop = getSourceProps(urls.desktop ?? []).concat(sourcesMobile);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(VideoMobile, {
                poster: posterUrl?.mobile,
                preload: "none",
                ...videoProps,
                children: [
                    sourcesMobile.map(({ key, src, type })=>/*#__PURE__*/ _jsx("source", {
                            src: src,
                            type: type
                        }, key)),
                    description
                ]
            }),
            /*#__PURE__*/ _jsxs(VideoDesktop, {
                poster: posterUrl?.desktop || posterUrl?.mobile,
                preload: "none",
                ...videoProps,
                children: [
                    sourcesDesktop.map(({ key, src, type })=>/*#__PURE__*/ _jsx("source", {
                            src: src,
                            type: type
                        }, key)),
                    description
                ]
            })
        ]
    });
};

//# sourceMappingURL=Video.js.map